import React, { useEffect, useState, createRef } from 'react';
import classNames from 'classnames';
import Image from '../Image';

const TABBABLE_ELEMENTS = 'a[href], button';
const KEYCODE_ESC = 27;
const KEYCODE_TAB = 9;

const ImageZoom = (props) => {
  const zoomImage = createRef();
  const zoomTrigger = createRef();

  const [isZoomed, setIsZoomed] = useState(false);

  useEffect(() => {
    //Listen for esc key
    const keyListener = (event) => {
      const keyCode = event.which || event.keyCode; // Get the current keycode

      if (keyCode === KEYCODE_ESC) {
        removeZoomClassName();
        setIsZoomed(false);
      }
    };

    document.addEventListener('keydown', keyListener, false);
  });

  function keepFocus() {
    const context = zoomImage.current;
    const allTabbableElements = context.querySelectorAll(TABBABLE_ELEMENTS);
    const firstTabbableElement = allTabbableElements[0];
    const lastTabbableElement =
      allTabbableElements[allTabbableElements.length - 1];

    const keyListener = (event) => {
      var keyCode = event.which || event.keyCode; // Get the current keycode
      // Polyfill to prevent the default behavior of events
      event.preventDefault =
        event.preventDefault ||
        function () {
          event.returnValue = false;
        };

      // If it is TAB
      if (keyCode === KEYCODE_TAB) {
        // Move focus to first element that can be tabbed if Shift isn't used
        if (event.target === lastTabbableElement && !event.shiftKey) {
          event.preventDefault();
          firstTabbableElement.focus();

          // Move focus to last element that can be tabbed if Shift is used
        } else if (event.target === firstTabbableElement && event.shiftKey) {
          event.preventDefault();
          lastTabbableElement.focus();
        }
      }
    };

    context.addEventListener('keydown', keyListener, false);
  }

  function removeZoomClassName() {
    document.getElementsByTagName('html')[0].classList.remove('is-img-zoom');
  }

  function addZoomClassName() {
    document.getElementsByTagName('html')[0].classList.add('is-img-zoom');
  }

  function handleClick(e) {
    e.preventDefault();
    //Keep focus within zoom modal
    keepFocus();
    //Reset focus state
    if (isZoomed) {
      removeZoomClassName();
      zoomTrigger.current.focus();
    } else {
      addZoomClassName();
      zoomImage.current.focus();
    }

    setIsZoomed(!isZoomed);
  }

  const {
    ImageUrl,
    Description,
    ImageText,
    UniqueBlockId,
    UseZoom,
    ShowCaption,
    ShowPhotoCred,
  } = props;

  if (!UseZoom) return props.children;

  const zoomClass = classNames({
    'c-imageblock__zoom__overlay': true,
    'c-imageblock__zoom__overlay--zoomed': isZoomed,
  });

  return (
    <div className="c-imageblock__zoom">
      <a
        ref={zoomTrigger}
        className="c-imageblock__zoom__trigger"
        onClick={(e) => handleClick(e)}
        aria-controls={UniqueBlockId}
        aria-expanded={isZoomed}
        href={ImageUrl}
      >
        {props.children}
        <span className="show-for-sr">Förstora bilden</span>
      </a>

      <div
        id={UniqueBlockId}
        className={zoomClass}
        aria-hidden={!isZoomed}
        onClick={(e) => handleClick(e)}
      >
        <div
          ref={zoomImage}
          onClick={(e) => e.stopPropagation()}
          tabIndex="-1"
          className="c-imageblock__zoom__image"
        >
          {isZoomed && (
            <div>
              <figure className="c-imageblock__zoom__image__inner">
                <Image ImageUrl={ImageUrl} Alt={Description} {...props} />

                {ShowCaption &&
                  (ImageText ||
                    (ShowPhotoCred &&
                      (props.Photographer || props.Illustrator))) && (
                    <figcaption className="c-imageblock__zoom__text">
                      {ImageText}
                    </figcaption>
                  )}
              </figure>
              <button
                className="c-imageblock__zoom__image__close"
                type="button"
                onClick={(e) => handleClick(e)}
                aria-controls={UniqueBlockId}
                aria-expanded={isZoomed}
              >
                <span className="show-for-sr">Stäng</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageZoom;
